/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvitationContextResponseEnterprisePoolOfFreelancers
 */
export interface InvitationContextResponseEnterprisePoolOfFreelancers {
    /**
     * 
     * @type {number}
     * @memberof InvitationContextResponseEnterprisePoolOfFreelancers
     */
    nbFreelancersInWorkCollaborationPool?: number;
}

/**
 * Check if a given object implements the InvitationContextResponseEnterprisePoolOfFreelancers interface.
 */
export function instanceOfInvitationContextResponseEnterprisePoolOfFreelancers(value: object): value is InvitationContextResponseEnterprisePoolOfFreelancers {
    return true;
}

export function InvitationContextResponseEnterprisePoolOfFreelancersFromJSON(json: any): InvitationContextResponseEnterprisePoolOfFreelancers {
    return InvitationContextResponseEnterprisePoolOfFreelancersFromJSONTyped(json, false);
}

export function InvitationContextResponseEnterprisePoolOfFreelancersFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationContextResponseEnterprisePoolOfFreelancers {
    if (json == null) {
        return json;
    }
    return {
        
        'nbFreelancersInWorkCollaborationPool': json['nbFreelancersInWorkCollaborationPool'] == null ? undefined : json['nbFreelancersInWorkCollaborationPool'],
    };
}

export function InvitationContextResponseEnterprisePoolOfFreelancersToJSON(value?: InvitationContextResponseEnterprisePoolOfFreelancers | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nbFreelancersInWorkCollaborationPool': value['nbFreelancersInWorkCollaborationPool'],
    };
}

